import React, { Component } from "react";
import axios from "axios";
import { API_BASE_URL,  TYPE_SUCCESS, TYPE_FAIL, INTERVAL, SAMPLE_FILE_URL } from 'assets/constants/Constants';
import { REFRESH_ICON } from "assets/constants/Icons";
import Spinner from "components/Spinner";
import MaterialTable from "material-table";
import { validateIsoDateFormat, defaultFormatDateTime, validateBitStatusAlarms } from "lib/utils"
import CSVFileReader from 'components/CSVFileReader';
import ShowToast from 'components/ShowToast';

export class AMI_AMR_MeterReadingPage extends Component {
    constructor (props) {
        super (props)

        this.state = {
            isLoading: true,
            meterReadings: [],
            meterRadarReadings: [],
            liveSyncIconClass: "enable-icon",
            toggleLiveSyncIconClass: true,
            importList: []
        }

        this.liveSyncIconClassToggleInterval = null;
        this.meterReadingsGetInterval = null;
    }

    arrangeReadingList = (array) => {
        const meterListArray = [...this.state.meterReadings];
        if(Array.isArray(array)){
            array.forEach((item) => {
                const index = meterListArray.findIndex(findeItem => findeItem.meter_serial_no === item.meter_serial_no);
                if(index === -1){
                    meterListArray.push(item)
                }
                else{
                    meterListArray[index].meter_reading = item.meter_reading;
                    meterListArray[index].meter_reading_status = item.meter_reading_status;
                    meterListArray[index].receive_date_time = item.receive_date_time;
                    meterListArray[index].alarm_type = item.alarm_type;
                    meterListArray[index].created_date_time = item.created_date_time;
                    meterListArray[index].updated_date_time = item.updated_date_time;
                }
            });
            return meterListArray;
        }
        else{
            return array;
        }
    }

    arrangeRadarReadingList = (array) => {
        const meterListArray = [...this.state.meterRadarReadings];
        if (Array.isArray(array)) {
            array.forEach((item) => {
                const index = meterListArray.findIndex(findeItem => findeItem.meter_serial_no === item.meter_serial_no);
                if (index === -1) {
                    meterListArray.push(item)
                }
                else {
                    meterListArray[index].level_distance_reading = item.level_distance_reading;
                    meterListArray[index].meter_status = item.meter_status;
                    meterListArray[index].network_time_stamp = item.network_time_stamp;
                    meterListArray[index].alarm_type = item.alarm_type;
                    meterListArray[index].created_date_time = item.created_date_time;
                    meterListArray[index].updated_date_time = item.updated_date_time;
                }
            });
            return meterListArray;
        }
        else {
            return array;
        }
    }

    async componentDidMount() {
        const meterReadings = await this.getMeterReadings();
        const meterRadarReadings = await this.getMeterRadarReadings();
        const updatedList = this.arrangeReadingList(meterReadings.data.result);
        const updatedRadarList = this.arrangeRadarReadingList(meterRadarReadings.data.result)
        // this.liveSyncIconClassToggleInterval = setInterval( () => {
        //     this.setState({
        //         toggleLiveSyncIconClass: !this.state.toggleLiveSyncIconClass,
        //         liveSyncIconClass: this.state.toggleLiveSyncIconClass ? "enable-icon" : "disable-icon"
        //     });
        // }, 1000);

        // this.meterReadingsGetInterval = setInterval( async () => {
        //     const meterReadings = await this.getMeterReadings();
        //     const meterRadarReadings = await this.getMeterRadarReadings();
        //     const updatedList = this.arrangeReadingList(meterReadings.data.result);
        //     const updatedRadarList = this.arrangeRadarReadingList(meterRadarReadings.data.result)
        //     this.setState({
        //         meterReadings: updatedList,
        //         meterRadarReadings: updatedRadarList
        //     });
        // }, 5000);

        this.setState({
            meterReadings: updatedList,
            meterRadarReadings: updatedRadarList,
            isLoading: false
        });
    }

    componentWillUnmount() {
        clearInterval(this.liveSyncIconClassToggleInterval);
        clearInterval(this.meterReadingsGetInterval);
    }

    getMeterReadings = async () => {
        return await axios.get(`${API_BASE_URL}/readings/AMI-AMR/${sessionStorage.getItem('siteId')}`);
    }

    getMeterRadarReadings = async () => {
        return await axios.get(`${API_BASE_URL}/radar/readings/AMI-AMR/${sessionStorage.getItem('siteId')}`);
    }

    showMeterReadingHandler = (item) => {
        if(item){
            const rowItem = {
                serial_number:item.meter_serial_no,
                ...item
            }
            this.props.history.push({
                pathname: "/meter-reading",
                state: {rowItem, pageName:"AMI Readings", pathName: "ami-amr-meter-reading-page"}
            });
        }
        else{
            this.props.history.push({
                pathname: "/meter-reading",
                state: null
            });
        }
    }


    handleFile = async (fileData) => {
        if (fileData[0].errors && fileData[0].errors.length === 0) {
            const importPromise = fileData.map(async (importItem, index) => {
                if (index !== 0) {
                    const innerPromiseResult = await new Promise(async (resolve) => {
                        const rawAlarmStatus = importItem.data[4] || "None"; ;
                        const alarmStatusArray = rawAlarmStatus.split(',').map(item => {
                            return item.trim();
                        });
                  
                        if (fileData[index].data[0]) {
                            resolve({
                                meter_serial_no: importItem.data[0] !== undefined ? importItem.data[0] : ""   ,
                                meter_date_time: importItem.data[1] !== undefined ?  importItem.data[1] : "" ,
                                meter_totalizer_value: importItem.data[2] !== undefined ? importItem.data[2] : "" ,
                                meter_unit: importItem.data[3] !== undefined ? importItem.data[3] : "",
                                meter_alarm_status: alarmStatusArray
                            });
                        }
                        else {
                            resolve(null);
                        }
                    });
                    return innerPromiseResult;
                }
            });

            let importResult = await Promise.all(importPromise);
            let requestParameter = null;
            importResult = importResult.filter((mapItem) => mapItem !== null);
            importResult = importResult.filter((item) => item);
            if (importResult.length > 0) {
                this.setState({
                    importList: [...importResult]
                })
            }
            const sitePromise = this.state.importList.map(async (item, index) => {
                this.setState({ isLoading: true })
                return new Promise(async (resolve) => {
                    requestParameter = {
                        meterSerialNumber: item.meter_serial_no,
                        meterDateAndTime: item.meter_date_time,
                        meterTotalizerReading: item.meter_totalizer_value,
                        meterReadingUnit: item.meter_unit,
                        meterAlarmStatus: item.meter_alarm_status,
                    }
                    const readingsResponse = await axios.post(`${API_BASE_URL}/import/csv/readings`, requestParameter);
                    resolve(readingsResponse);
                })
            });

            const meterResponse = await Promise.all(sitePromise);
            if (meterResponse.length > 0 && meterResponse.length === importResult.length) {
                ShowToast('Imported Readings created successfully', TYPE_SUCCESS, INTERVAL, this.props, "");
                this.setState({
                    importList: [],
                    isLoading: false
                });
            }

        }

        else {
            ShowToast('Something went wrong. Please try after sometime!', TYPE_FAIL, INTERVAL, this.props, "");
        }
    };

    handleRefresh = async () => {
        this.setState({ isLoading: true })
        await this.getMeterReadings(1, this.state.pageSize);
        this.setState({ isLoading: false })
    }


    render () {
        if (this.state.isLoading) {
            return (
                <Spinner />
            );
        }
        else {
            return (
                <div className="main-content">
                    <div className="live-sync-ami-amr-icon-and-text-container">
                        {/* <i className={ `${REFRESH_ICON} ${this.state.liveSyncIconClass} rotate`}></i>
                        <label className={`${this.state.liveSyncIconClass}`}>Syncing...</label> */}
                        <div className="ami-amr-heading" >AMI-AMR READINGS</div>
                        <div className="live-sync-info">
                            <i
                                onClick={this.handleRefresh}
                                className={`${REFRESH_ICON}`}
                            ></i>
                        </div>
                        {/* <div className="csv-import-wrapper">
                            <CSVFileReader handleFile={this.handleFile}>
                                <button className="brand-button">Import CSV</button>
                            </CSVFileReader>
                        </div> */}
                    </div>
                    
                    <div className="border list-table-div" style={{marginBottom:50}}>
                        {(this.state.meterReadings.length > 0) || (this.state.meterRadarReadings.length > 0) ? (
                            <MaterialTable
                                columns={[
                                    { title: "Serial Number", field: "meter_serial_no", cellStyle:{color:"#000000", fontSize: 14} },
                                    { title: "Date", field: "receive_date_time", cellStyle:{color:"#808080", fontSize: 14} },
                                    { title: "Reading", field: "meter_reading", cellStyle:{color:"#808080", fontSize: 14} },
                                    { title: "Meter Status", field: "meter_status", cellStyle:{color:"#808080", fontSize: 14} },
                                    { title: "Receiver", field: "receiver", cellStyle: (e, rowData) => {
                                        if (rowData.receiver === "AMI") {
                                            return { color: "blue", fontSize: 14, fontWeight: "bold"}
                                        }
                                        else {
                                            return { color: "green", fontSize: 14, fontWeight: "bold"}
                                        }
                                    } },
                                    { title: "Gateway Device ID", field: "gway_device_id", cellStyle:{color:"#808080", fontSize: 14} },
                                    { title: "Field Strength", field: "field_strengthG", cellStyle:{color:"#808080", fontSize: 14} },
                                    { title: "Alarm Type", field: "alarm_type", cellStyle:{color:"#808080", fontSize: 14} }
                                ]}
                                data={[
                                    ...this.state.meterReadings.map( (element, index) => {
                                        return {
                                            meter_serial_no: element.meter_serial_no,
                                            receive_date_time: validateIsoDateFormat(element.receive_date_time) ? defaultFormatDateTime(element.receive_date_time): element.receive_date_time,
                                            meter_reading: element.meter_reading ? element.meter_reading: "NA" ,
                                            meter_status: element.meter_status,
                                            receiver : element.original_receiver !== "AMI" ? (element.original_receiver !== "AMR"  ? (validateIsoDateFormat(element.receive_date_time) ? "AMI" : element.original_receiver)  : "AMR") : "AMI",
                                            gway_device_id: element.gway_device_id ? element.gway_device_id : "NA" ,
                                            field_strengthG: element.field_strengthG ? element.field_strengthG : "NA" ,
                                            alarm_type: validateBitStatusAlarms(element.alarm_type),
                                        }
                                    }),
                                    ...this.state.meterRadarReadings.map((element) => {
                                        return {
                                            meter_serial_no: element.meter_serial_no,
                                            receive_date_time: validateIsoDateFormat(element.network_time_stamp) ? defaultFormatDateTime(element.network_time_stamp): element.network_time_stamp,
                                            meter_reading: element.level_distance_reading ? element.level_distance_reading : "NA",
                                            meter_status: element.meter_status,
                                            receiver: "AMI",
                                            gway_device_id: element.network_info,
                                            field_strengthG: element.field_strengthG ? element.field_strengthG : "None",
                                            alarm_type: validateBitStatusAlarms(element.alarm_type),
                                        }
                                    })
                                ]}
                                onRowClick = {(event, rowData) => {
                                    this.showMeterReadingHandler(rowData)
                                }}
                                options={{
                                    headerStyle: {
                                        color: "#999998",
                                        fontWeight: "bold",
                                        fontSize: 15
                                    },
                                    columnsButton: true,
                                    pageSize:25,
                                    pageSizeOptions:[25,50,75,100],
                                    exportButton: true,
                                    exportAllData: true, 
                                    exportFileName: "Reading Data"
                                }}
                            />
                        ) : (
                            <div className="text-center pt-2">
                                <label>Records not found!</label>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    }
}

export default AMI_AMR_MeterReadingPage;